import { useEffect, useState } from 'react'
import { Mixpanel } from '../utils/Mixpanel'

export const useMixpanelTrackView = (
  event: string,
  eventProps: any = undefined,
  refreshProps: any = [],
) => {
  const [_refresh, setRefresh] = useState(false)

  const refresh = () => {
    setRefresh(true)
  }

  useEffect(() => {
    Mixpanel.track(event, eventProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_refresh, ...refreshProps])

  return refresh
}
